 $("#aCartSidebar").click(function() {
       $('#main-wrapper').addClass('cart-menu');
   	   $('#main-wrapper').removeClass('cart-menu-removed');
        return false;
    });

$("#close-cartbar").click(function() {
       $('#main-wrapper').removeClass('cart-menu');
  	   $('#main-wrapper').addClass('cart-menu-removed');
    });



function adjustQty(variantId,flag) {
        var qty = $("#updates-"+variantId).val();
        
        if(flag != 3) {
          if(flag == 1) {          
            qty--;          
          } else if(flag == 2) {
            qty++;
          }
        }
        
        if(qty<0) {
          return false;
        }
        $("#updates-"+variantId).val(qty);
        
        $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    dataType: 'json',
                    data: {
                        quantity: qty,
                        id: variantId
                    },
                    success: function(cart) {
                        updateCartData(cart);                        
                    },
                    error: function(response) {
                        alert(response);
                    }
                });
      }
      
      function updateCartData(cart) {
        
        if(cart.item_count > 0) {
    	$("#paymentAddDiv").css('display','block');
          
       $("#cartMainContent").html('<div class="ajaxcart__inner">');
    
    var cartItems = '';
    
          var currencyArray = [];
          currencyArray["EUR"] = "€";
          currencyArray["USD"] = "$";
          currencyArray["CAD"] = "$";
          currencyArray["INR"] = "";
          currencyArray["GBP"] = "£";
          currencyArray["AUD"] = "$";
          currencyArray["JPY"] = "¥";
          currencyArray["HKD"] = "$";
          
          var currencyFormat = currencyArray[$("#currencies").val()];
          
   	$.each(cart.items, function(index, cartItem) {
      var price = Currency.convert(cartItem.line_price,shopCurrency,$("#currencies").val());
      price = (price/100).toFixed(2);
      
      var cartItems= '<div class="ajaxcart__product">'+
          '<div class="ajaxcart__row">'+
            '<div class="grid">'+
              '<div class="grid__item one-quarter">'+
                '<a href="'+cartItem.url+'" class="ajaxcart__product-image"><img src="'+cartItem.image+'" alt="'+cartItem.title+'"></a>'+
        
              '</div>'+
              '<div class="grid__item three-quarters">'+
                '<p>'+
                  '<a href="'+cartItem.url+'" class="ajaxcart__product-name">'+cartItem.title+'</a>'+
                '</p>'+

                '<div class="grid--full display-table">'+
                  '<div class="grid__item display-table-cell one-half">'+
                    '<div class="ajaxcart__qty" style="margin-top:30px;">'+
                      '<button type="button" class="ajaxcart__qty-adjust ajaxcart__qty--minus" onclick="adjustQty('+cartItem.variant_id+',1)">'+
                        '<span class="fallback-text" aria-hidden="true">−</span>'+
                        '<span class="visually-hidden">Reduce item quantity by one</span>'+
                      '</button>'+
                      '<input type="text" id="updates-'+cartItem.variant_id+'" class="ajaxcart__qty-num" value="'+cartItem.quantity+'" min="0" data-id="1032636197:22f142fc73600765bcb9de1633b6a754" data-line="1" aria-label="quantity" pattern="[0-9]*" onblur="adjustQty('+cartItem.variant_id+',3)">'+
                      '<button type="button" class="ajaxcart__qty-adjust ajaxcart__qty--plus" onclick="adjustQty('+cartItem.variant_id+',2)">'+
                        '<span class="fallback-text" aria-hidden="true">+</span>'+
                        '<span class="visually-hidden">Increase item quantity by one</span>'+
                      '</button>'+
                    '</div>'+
                  '</div>'+
                  '<div class="grid__item display-table-cell one-half text-right">'+
                    
                      '<span>'+currencyFormat+price+' '+$("#currencies").val()+'</span>'+
                    
                    '</div>'+
                  '</div>'+
                  
                  '</div>'+
                '</div>'+
              '</div>'+
            '</div>';
      
      $("#cartMainContent").append(cartItems);
      
    });
    
    var totalPrice = Currency.convert(cart.total_price,shopCurrency,$("#currencies").val());
    totalPrice = (totalPrice/100).toFixed(2);
    
    $("#cartMainContent").append('</div>'+ 
      '<div class="ajaxcart__footer">'+
        '<div class="grid--full">'+
          '<div class="grid__item two-thirds">'+
            '<p>Subtotal</p>'+
          '</div>'+
          '<div class="grid__item one-third text-right">'+
            '<p>'+currencyFormat+totalPrice+' '+$("#currencies").val()+'</p>'+
          '</div>'+          
        '</div>'+        
      '</div>'+
    '</form>');
      
          } else {
        $("#paymentAddDiv").css('display','none');
        $("#cartMainContent").html('Your cart is currently empty.');
    }  
        
        $('#item_count').text(cart.item_count);        
        
      }


//Currency specific url
$.urlParam = function(name){
          var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
          if (results==null){
             return null;
          }
          else{
             return decodeURI(results[1]) || 0;
          }
      }
      
      //Check if url contains currency if yes then auto select it and remove from url
      if($.urlParam('currency') != '' && $.urlParam('currency') != null) {
        var urlCurrency = $.urlParam('currency').toUpperCase();
               
        if(urlCurrency == 'USD' || urlCurrency == 'CAD' || urlCurrency == 'INR' || urlCurrency == 'GBP' || urlCurrency == 'AUD' || urlCurrency == 'JPY' || urlCurrency == 'EUR'  || urlCurrency == 'HKD') {
          $("#currencies").val(urlCurrency).trigger('change');
          
          var url = window.location.href.replace('&currency='+$.urlParam('currency'),'');
          url = url.replace('?currency='+$.urlParam('currency'),'');
          window.history.replaceState({}, document.title, url);
        }
      }

		
